import { apiPost, apiGet, apiDelete, apiPut, getHeaders, generateUrl } from '../utils/api'
import Hotjar from '@hotjar/browser'

//Update apis
export const updateShopAPI = (data) => {
  Hotjar.event('update_shop')
  return apiPost(`mgmt/shops/${data.id}`, data)
}

export const updateShopContractAPI = (contract) => {
  Hotjar.event('update_shop_contract')
  return apiPost(`mgmt/contracts/${contract.id}`, contract)
}

export const updateShopFeatureAPI = (data) => {
  Hotjar.event('update_shop_feature')
  return apiPost(`mgmt/shops/features/update`, data)
}

export const updateSpecificShopDataAPI = (data) => {
  Hotjar.event('update_specific_shop_data')
  return apiPost(`mgmt/shops/updateShop/${data.shopId}`, data)
}

export const updateAssignedShopIdListAPI = (id, data) => {
  Hotjar.event('update_assigned_shop_id')
  return apiPut(`mgmt/labelmaker/${id}`, data).then((response) => response.data)
}

export const updateEnableDCHShopsAPI = (data) => {
  return apiPost(`mgmt/shops/dispatch/enableshops`, data)
}

// get apis

export const getCurrentStoreKeyAPI = () => {
  return apiGet(`mgmt/storekeys/current`)
}

export const getShopListAPI = () => {
  return apiGet('mgmt/shops')
}

export const getShopTerminalsAPI = (shopId) => {
  return apiGet(`mgmt/terminals/${shopId}/shopTerminal`)
}

export const getTerminalsByShopsAPI = (shopIds) => {
  Hotjar.event('terminals_by_shop')
  return apiPost(`mgmt/terminals/terminalsByShops`, shopIds)
}

export const getContractsAPI = () => {
  return apiGet(`mgmt/contracts/`)
}

export const getCompanyFeaturesAPI = () => {
  return apiGet(`mgmt/company/features`)
}

export const getFeeListAPI = (feeType) => {
  return apiGet(`mgmt/shop/fee/${feeType}`)
}

export const getShopFeaturesAPI = () => {
  return apiGet(`mgmt/shops/features`)
}

export const getShopLabelsAPI = (shopId) => {
  return apiGet(`mgmt/labelmaker`)
}

export const searchShopDispatchAPI = (term) => {
  return apiGet(`mgmt/shops/dispatch/search?term=${term}&start=0&limit=50`)
}

// export const getLabelImageAPI = (templateId) => {
//   return apiGet(`mgmt/labelmaker/${templateId}thumbnail`).then(
//     (response) => response.data
//   );
// }

export const getLabelThumbnailAPI = async (productId) => {
  var response = await fetch(generateUrl(`mgmt/labelmaker/${productId}/thumbnail`), {
    headers: getHeaders(),
    method: 'GET',
  })
  return response.blob()
}

export const getLabelImageAPI = async (productId) => {
  var response = await fetch(generateUrl(`mgmt/labelmaker/${productId}/image`), {
    headers: getHeaders(),
    method: 'GET',
  })
  return response.blob()
}

export const getLabelTemplatesAPI = (data) => {
  return apiGet('mgmt/labelmaker', data)
}

export const getLabelTemplateByIdAPI = (id) => {
  return apiGet(`mgmt/labelmaker/${id}`).then((response) => response.data)
}

export const getIsLabelMakerEnabled = () => {
  return apiGet('mgmt/labelmaker/enabled')
}

//Add APIs

export const addShopAPI = (shop, createCompanyProducts) => {
  Hotjar.event('add_shop')
  return apiPost(`mgmt/shops?createCompanyProducts=${createCompanyProducts}`, shop)
}

export const addShopContractAPI = (contract) => {
  Hotjar.event('add_shop_contract')
  return apiPost(`mgmt/contracts/`, contract)
}

export const generateKeyAPI = () => {
  Hotjar.event('generate_key')
  return apiPost(`mgmt/storekeys`)
}

export const addUpdateFeeAPI = (feeType, data) => {
  Hotjar.event('update_fee')
  return apiPost(`mgmt/shop/fee/${feeType}`, data)
}

//Delete Apis
export const deleteProductsAPI = (data) => {
  Hotjar.event('delete_products')
  return apiPost(`mgmt/reset/delete/products`, data)
}

export const deleteProductStockAPI = (data) => {
  Hotjar.event('deleteProducts_stock')
  return apiPost(`mgmt/reset/delete/product/stock`, data)
}

export const getPaymentOptionsAPI = () => {
  return apiGet(`mgmt/settings/admin/paymentoptions`)
}
export const getPaymentOptionsOrderByPriorityAPI = () => {
  return apiGet(`mgmt/settings/admin/paymentOptionsOrderByPriority`)
}
export const savePaymentOptionsAPI = (data) => {
  Hotjar.event('save_payment_options')
  return apiPost('mgmt/settings/paymentoptions', data)
}

export const getPaymentProvidersAPI = () => {
  return apiGet(`mgmt/settings/paymentproviders`)
}

export const savePaymentProvidersAPI = (data) => {
  Hotjar.event('save_payment_providers')
  return apiPost('mgmt/settings/paymentproviders', data)
}

export const getPartnersAPI = () => {
  return apiGet(`mgmt/settings/partnerkeys`)
}

//Notifications

export const getNotificationsListAPI = (data) => {
  return apiGet('mgmt/notification/list', data)
}

export const addNotificationAPI = (data) => {
  Hotjar.event('add_notification')
  return apiPost('mgmt/notification', data)
}

export const updateNotificationAPI = (notification) => {
  Hotjar.event('update_notification')
  return apiPut(`mgmt/notification/${notification.id}`, notification)
}

export const deleteNotificationAPI = (notificationId) => {
  Hotjar.event('delete_notification')
  return apiDelete(`mgmt/notification/${notificationId}`)
}

export const updateNotificationListAPI = (notifications) => {
  Hotjar.event('update_notification_list')
  return apiPut(`mgmt/notification/list`, notifications)
}

export const getDeliveryTaxRateAPI = (shopId) => {
  return apiGet(`mgmt/deliveryTaxRate?shopId=${shopId}`)
}

export const postDeliveryTaxRateAPI = (data) => {
  Hotjar.event('delivery_tax_rate')
  return apiPost(`mgmt/deliveryTaxRate`, data)
}

export const updateDeliveryTaxRateAPI = (data) => {
  Hotjar.event('update_delivery_tax_rate')
  return apiPut(`mgmt/deliveryTaxRate/${data.id}`, data)
}

export const deleteDeliveryTaxRateAPI = (id) => {
  Hotjar.event('delete_delivery_tax_rate')
  return apiDelete(`mgmt/deliveryTaxRate/${id}`)
}

export const getShopTaxesDisplayNamesAPI = () => {
  return apiGet(`mgmt/shops/taxes`)
}

export const updateShopTaxesDisplayNamesAPI = (data) => {
  Hotjar.event('update_shop_taxes_display_names')
  return apiPost(`mgmt/shops/taxes`, data)
}

export const getShopFlowerTypes = (shopIdsText) => {
  return apiGet(`mgmt/shops/flowerTypes${shopIdsText ? `?shopIds=${shopIdsText}` : ''}`)
}



// WEBPACK FOOTER //
// ./src/api/shop.js